<ng-container *ngIf="(documentSubject | async) as documentStorageId; else nullableDocumentItem">
    <div
            (click)="onPreviewDocument()"
            [ngClass]="{'read-only': readonly}"
            class="file-upload view"
    >
        <div>
            <input
                #fileUploadInput
                (change)="onDocumentChange($event)"
                *ngIf="!readonly"
                class="file_upload"
                type="file"
            >

            <a
                    (click)="removeDocument()"
                    *ngIf="file"
                    href="javascript:void(0);"
            >
                <i class="icon-cancel ml-1" aria-hidden="true"></i>
            </a>

            <ng-container *ngIf="(documentErrorSubject | async) as errors">
                <div *ngIf="errors.length > 0" class="file-upload-errors-container">
                    <ul>
                        <li
                                *ngFor="let error of errors"
                                class="text-center"
                        >{{error}}</li>
                    </ul>
                </div>
            </ng-container>

            <div class="file-upload-preview">
        <span
                [ngClass]="{
            'icon-wrapper': hasGetDocumentError || (imageFileTypes.indexOf(getFileTypeByName(documentStorageId)) < 0),
            'has-get-document-error': hasGetDocumentError
          }"
                class="file-upload-render"
        >
            <ng-container *ngIf="!file; else uploadedFileContainer">
              <ng-container *ngIf="!hasGetDocumentError; else notFoundImage">
                <ng-container *ngIf="imageFileTypes.indexOf(getFileTypeByName(documentStorageId)) >= 0; else documentPreview">
                  <img
                          *ngIf="(getDocument(documentStorageId) | async) as trustedResource;"
                          (load)="hiddenPreloader = true;"
                          [src]="trustedResource"
                          alt=""
                          class="file-upload-preview-img"
                  >

                  <app-preloader [ngStyle]="{'display': !hiddenPreloader ? 'block' : 'none' }"></app-preloader>
                </ng-container>

                <ng-template #documentPreview>
                  <ng-container *ngIf="initNonImageDocument(documentStorageId) | async">
                    <i class="icon-pdf" aria-hidden="true"></i>
                  </ng-container>
                </ng-template>
              </ng-container>

              <ng-template #notFoundImage>
                <div class="file-upload view">
                  <div class="file-upload-message">
                    <i class="icon-document-fail" aria-hidden="true"></i>
                    <p
                            class="file-upload-infos-message"
                            [innerHTML]="'UPLOAD_DOCUMENT.NOT_EXISTING_FILE' | translate"
                    ></p>
                    <ng-container *ngIf="(documentErrorSubject | async) as errors">
                      <p
                              *ngFor="let error of errors"
                              class="file-upload-error text-danger"
                      >
                        {{ error }}
                      </p>
                    </ng-container>
                  </div>
                  <div class="mask rgba-stylish-slight"></div>
                </div>
              </ng-template>
            </ng-container>

            <ng-template #uploadedFileContainer>
              <ng-container *ngIf="imageFileTypes.indexOf(file!.type) >= 0; else documentFile">
                <span class="file-upload-render">
                  <img [src]="documentUrl" alt="" class="file-upload-preview-img">
                </span>
              </ng-container>

              <ng-template #documentFile>
                <ng-container *ngIf="file!.type === pdfFileType; else notAllowedFile">
                  <span class="file-upload-render icon-wrapper">
                    <i class="icon-pdf" aria-hidden="true"></i>
                  </span>
                </ng-container>

                <ng-template #notAllowedFile>
                  <span class="file-upload-render icon-wrapper">
                    <i class="icon-document-fail" aria-hidden="true"></i>
                  </span>
                </ng-template>
              </ng-template>
            </ng-template>
        </span>

                <div *ngIf="hiddenPreloader" class="file-upload-infos">
                    <div *ngIf="!readonly" class="file-upload-infos-inner">
                        <p class="file-upload-filename">
              <span class="file-upload-filename-inner">
                {{ !file ? documentStorageId : file.name }}
              </span>
                        </p>
                        <p
                                class="file-upload-infos-message"
                                [innerHTML]="'UPLOAD_DOCUMENT.INFO_MESSAGE' | translate"
                        ></p>
                        <p
                                *ngIf="hint"
                                class="file-upload-infos-message"
                                [innerHTML]="hint"
                        ></p>
                        <p
                                *ngIf="hint"
                                class="file-upload-infos-message"
                                [innerHTML]="hint"
                        ></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #nullableDocumentItem>
    <div class="file-upload view">
        <div>
            <input
                    *ngIf="!readonly"
                    #fileUploadInput
                    (change)="onDocumentChange($event)"
                    class="file_upload"
                    type="file"
            >

            <ng-container *ngIf="!file; else filePreview">
                <div class="file-upload-message">
                    <ng-container *ngIf="!readonly; else readOnlyPreview">
                        <i class="icon-upload-1" aria-hidden="true"></i>
                        <p
                                class="file-upload-infos-message"
                                [innerHTML]="'UPLOAD_DOCUMENT.INFO_MESSAGE' | translate"
                        ></p>
                        <p
                                *ngIf="hint"
                                class="file-upload-infos-message"
                                [innerHTML]="hint"
                        ></p>
                    </ng-container>

                    <ng-template #readOnlyPreview>
                        <i class="icon-cancel" aria-hidden="true"></i>
                        <p
                                class="file-upload-infos-message"
                                [innerHTML]="'UPLOAD_DOCUMENT.NOT_FOUND_FILE' | translate"
                        ></p>
                        <p
                                *ngIf="hint"
                                class="file-upload-infos-message"
                                [innerHTML]="hint"
                        ></p>
                    </ng-template>

                    <ng-container *ngIf="(documentErrorSubject | async) as errors">
                        <p
                                *ngFor="let error of errors"
                                class="file-upload-error text-danger"
                        >
                            {{ error }}
                        </p>
                    </ng-container>
                </div>

                <div class="mask rgba-stylish-slight"></div>

            </ng-container>

            <ng-template #filePreview>
                <a
                        *ngIf="file"
                        (click)="removeDocument()"
                        href="javascript:void(0);"
                >
                    <i class="icon-cancel ml-1" aria-hidden="true"></i>
                </a>

                <ng-container *ngIf="(documentErrorSubject | async) as errors">
                    <div
                            *ngIf="errors.length > 0"
                            class="file-upload-errors-container"
                    >
                        <ul>
                            <li
                                    *ngFor="let error of errors"
                                    class="text-center"
                            >
                                {{error}}
                            </li>
                        </ul>
                    </div>
                </ng-container>

                <div class="file-upload-preview">
                    <ng-container *ngIf="(imageFileTypes.indexOf(file!.type) > 0) && documentUrl; else documentFile">
            <span class="file-upload-render">

              <img
                      (load)="hiddenPreloader = true;"
                      [src]="documentUrl"
                      alt=""
                      class="file-upload-preview-img"
              >
            </span>

                        <app-preloader [ngStyle]="{'display': !hiddenPreloader ? 'block' : 'none' }"></app-preloader>
                    </ng-container>

                    <ng-template #documentFile>
                        <ng-container *ngIf="file!.type === pdfFileType; else otherFile">
              <span class="file-upload-render icon-wrapper">
                <i class="icon-pdf" aria-hidden="true"></i>
              </span>
                        </ng-container>

                        <ng-template #otherFile>
              <span class="file-upload-render icon-wrapper">
                <i class="icon-document-fail" aria-hidden="true"></i>
              </span>
                        </ng-template>
                    </ng-template>

                    <div class="file-upload-infos">
                        <div class="file-upload-infos-inner">
                            <p class="file-upload-filename">
                                <span class="file-upload-filename-inner">{{ file!.name }}</span>
                            </p>
                            <p
                                    class="file-upload-infos-message"
                                    [innerHTML]="'UPLOAD_DOCUMENT.INFO_MESSAGE' | translate"
                            ></p>
                            <p
                                    *ngIf="hint"
                                    class="file-upload-infos-message"
                                    [innerHTML]="hint"
                            ></p>
                        </div>
                    </div>
                </div>
            </ng-template>

        </div>
    </div>
</ng-template>
